import { render, staticRenderFns } from "./TabsButton.vue?vue&type=template&id=140597c4&scoped=true&"
import script from "./TabsButton.vue?vue&type=script&lang=js&"
export * from "./TabsButton.vue?vue&type=script&lang=js&"
import style0 from "./TabsButton.vue?vue&type=style&index=0&id=140597c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140597c4",
  null
  
)

export default component.exports